import React from 'react';
import { styled } from '@mui/material';

import {
    ActivityList,
    Analytics,
    TaskList,
    GroupProgressInformation,
    TeamInformation,
} from 'components/organisms/Dashboard';
import { Container, Stack } from 'shell/components';

const Mobile = ({
    course,
    group = {},
    groupMembers = [],
    instructorMembers = [],
    status,
    myTasks = [],
    mySubtasks = [],
    currentAccountId,
    activityList,
    setActivitySettings,
}) => {
    return (
        <Container device={'mobile'}>
            <CustomStack spacing={4}>
                <Stack className={'dashboard-1'} spacing={4}>
                    <TeamInformation
                        groupName={group?.name}
                        courseName={course?.name}
                        members={groupMembers}
                        instructors={instructorMembers}
                        status={status}
                    />
                    <GroupProgressInformation />
                </Stack>
                <Stack className={'dashboard-2'} spacing={4}>
                    <Analytics students={groupMembers} />
                    <TaskList taskList={myTasks} subtaskList={mySubtasks} />
                    <ActivityList
                        currentAccountId={currentAccountId}
                        activityList={activityList}
                        groupMembers={groupMembers}
                        instructorMembers={instructorMembers}
                        setActivitySettings={setActivitySettings}
                    />
                </Stack>
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(-5),
        paddingBottom: theme.spacing(18),
        width: `calc(100% + ${theme.spacing(5 * 2)})`,
        background: theme.palette.ensightful.neutral[50],
    };
});

export default Mobile;
